module.exports = __webpack_public_path__ + "static/img/about_16.1a9b1fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_16.png
// module id = 6Jo9
// module chunks = 1